import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-end buttons-td" }
const _hoisted_2 = { class: "svg-icon svg-icon-3" }
const _hoisted_3 = { class: "svg-icon svg-icon-3" }
const _hoisted_4 = ["data-bs-target"]
const _hoisted_5 = { class: "svg-icon svg-icon-3" }
const _hoisted_6 = {
  key: 0,
  class: "svg-icon svg-icon-3"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "svg-icon svg-icon-3"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "svg-icon svg-icon-3" }
const _hoisted_12 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("td", _hoisted_1, [
    (_ctx.mapping.Actions?.pageLink)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: { path: _ctx.mapping.Actions.pageLink + _ctx.item[_ctx.mapping.PrimaryKey] },
          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr076.svg" })
            ])
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (_ctx.mapping.Actions?.editLink && !_ctx.mapping.ModalForm)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: { path: _ctx.mapping.Actions.editLink + _ctx.item[_ctx.mapping.PrimaryKey] },
          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
            ])
          ]),
          _: 1
        }, 8, ["to"]))
      : (_ctx.mapping.Actions?.editLink)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-modal', _ctx.item[_ctx.mapping.PrimaryKey]))),
            "data-bs-toggle": "modal",
            "data-bs-target": '#kt_modal_new_card_' + _ctx.routeKey,
            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
            ])
          ], 8, _hoisted_4))
        : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.mapping.RowButtons || []), (rowButton, rowButtonIndex) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: rowButtonIndex }, [
        (rowButton.type === 'link' && (!rowButton.showIf || rowButton.showIf(_ctx.item)))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: _normalizeClass(["btn btn-sm me-1", rowButton.iconOnly ? 'btn-icon btn-bg-light btn-active-color-primary' : (rowButton.variant ? 'btn-' + rowButton.variant : 'btn-light')]),
              to: _ctx.resolveRowLink(rowButton, _ctx.item)
            }, {
              default: _withCtx(() => [
                (rowButton.iconSvg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_component_inline_svg, {
                        src: rowButton.iconSvg
                      }, null, 8, ["src"])
                    ]))
                  : (rowButton.fontIcon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: _normalizeClass(rowButton.fontIcon)
                      }, null, 2))
                    : (!rowButton.iconOnly)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(rowButton.text), 1))
                      : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["class", "to"]))
          : (rowButton.type === 'button' && (!rowButton.showIf || rowButton.showIf(_ctx.item)))
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["btn btn-sm me-1", rowButton.iconOnly ? 'btn-icon btn-bg-light btn-active-color-primary' : (rowButton.variant ? 'btn-' + rowButton.variant : 'btn-light')]),
                type: "button",
                onClick: ($event: any) => (_ctx.$emit('row-action', { button: rowButton, item: _ctx.item }))
              }, [
                (rowButton.iconSvg)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createVNode(_component_inline_svg, {
                        src: rowButton.iconSvg
                      }, null, 8, ["src"])
                    ]))
                  : (rowButton.fontIcon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: _normalizeClass(rowButton.fontIcon)
                      }, null, 2))
                    : (!rowButton.iconOnly)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(rowButton.text), 1))
                      : _createCommentVNode("", true)
              ], 10, _hoisted_8))
            : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_ctx.mapping.Actions?.deleteLink)
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('delete', { id: _ctx.item[_ctx.mapping.PrimaryKey], index: _ctx.index })), ["prevent"])),
          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
        }, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mapping.Actions?.inactiveLink)
      ? (_openBlock(), _createElementBlock("a", {
          key: 4,
          href: "#",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('inactiveLink', { id: _ctx.item[_ctx.mapping.PrimaryKey], index: _ctx.index })), ["prevent"])),
          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
        }, [
          _createElementVNode("span", _hoisted_12, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}